import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export default function Inquiries() {
  const { t } = useI18n();
  const [list, setList] = useState([]);

  const load = async () => { const { data } = await api.get("/inquiries"); setList(data); };
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    await api.patch(`/inquiries/${id}?status=${status}`);
    load();
  };

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500">{t("nav.inquiries")}</div>
        <h1 className="font-heading text-3xl font-bold text-slate-900 tracking-tight mt-1">Public Inquiries</h1>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg overflow-x-auto">
        <table className="w-full text-sm" data-testid="inquiries-table">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50">
              {["Date", "Name", "Email", "Country", "Type", "Message", "Status", "Action"].map((h) => (
                <th key={h} className="py-3 px-4 text-left text-xs uppercase tracking-[0.2em] font-semibold text-slate-500">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {list.length === 0 ? (
              <tr><td colSpan={8} className="py-8 text-center text-slate-400">{t("common.no_data")}</td></tr>
            ) : list.map((i) => (
              <tr key={i.id} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="py-3 px-4 text-slate-700 whitespace-nowrap">{new Date(i.created_at).toLocaleDateString()}</td>
                <td className="py-3 px-4 font-medium text-slate-900">{i.name}</td>
                <td className="py-3 px-4">{i.email}</td>
                <td className="py-3 px-4">{i.country || "—"}</td>
                <td className="py-3 px-4"><span className="px-2 py-0.5 text-xs uppercase font-semibold rounded bg-[#0052CC]/10 text-[#0052CC]">{i.inquiry_type}</span></td>
                <td className="py-3 px-4 text-slate-600 max-w-xs truncate">{i.message}</td>
                <td className="py-3 px-4">
                  <span className={`px-2 py-0.5 text-xs font-semibold rounded ${i.status === "new" ? "bg-amber-100 text-amber-800" : i.status === "in_progress" ? "bg-blue-100 text-blue-800" : "bg-emerald-100 text-emerald-800"}`}>
                    {i.status}
                  </span>
                </td>
                <td className="py-3 px-4">
                  <select data-testid={`inquiry-status-${i.id}`} value={i.status} onChange={(e) => setStatus(i.id, e.target.value)} className="text-xs border border-slate-200 rounded px-2 py-1">
                    <option value="new">new</option>
                    <option value="in_progress">in_progress</option>
                    <option value="closed">closed</option>
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
